import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/route';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
      <ToastContainer newestOnTop />
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;